import React from 'react';

import * as styles from './styles';

export interface SkipLinksProps {
  links: {
    /* e.g. Skip to Navigation */
    content: string;
    /* HTML id of the element on the page you want to skip to  */
    sectionId: string;
  }[];
}

export const SkipLinks = ({ links }: SkipLinksProps) => (
  <div css={styles.skipLinksWrapper}>
    {links.map(({ content, sectionId }) => (
      <a css={styles.skipLink} href={`#${sectionId}`} key={sectionId}>
        {content}
      </a>
    ))}
  </div>
);
